import banner_logo from "./images/banner-logo.png";
import banner_sidelayer from "./images/banner-sidelayer.png";
import footer_logo from "./images/footer-logo.png";
import bannerapple_img1 from "./images/bannerapple-img1.png";
import bannergoogle_img2 from "./images/bannergoogle-img2.png";
import bannerphone1_img from "./images/bannerphone1-img.png";
import banner_sidecircle1 from "./images/banner-sidecircle1.png";
import banner_sidecircle2 from "./images/banner-sidecircle2.png";
import feature_circle from "./images/feature-circle.png";
import featurephoneback_img from "./images/featurephoneback-img.png";
import featurephone_img from "./images/featurephone-img.png";
import astrologer from "./images/astrologer.svg";
import chat from "./images/chat.svg";
import call from "./images/call.svg";
import horoscope from "./images/horoscope.svg";
import coslultation from "./images/coslultation.svg";
import search_sidecircle from "./images/search-sidecircle.png";
import search_phoneback from "./images/search-phoneback.png";
import search_phone1 from "./images/search-phone1.png";
import search_phone2 from "./images/search-phone2.png";
import search_phone3 from "./images/search-phone3.png";
import search_phone4 from "./images/search-phone4.png";
import manage_sidecircle from "./images/manage-sidecircle.png";
import manage_phoneback from "./images/manage-phoneback.png";
import manage_phone1 from "./images/manage-phone1.png";
import manage_phone2 from "./images/manage-phone2.png";
import statistics_sidelayer from "./images/statistics-sidelayer.png";
import faq_icon from "./images/faq_icon.png";
import image_sidecircle from "./images/image-sidecircle.png";
import image_videosession from "./images/image-videosession.png";
import offer_sidelayer from "./images/offer-sidelayer.png";
import ion_call from "./images/ion_call.png";
import ic_round_email from "./images/ic_round_email.png";
import no_user from "./images/no-user.jpg";
// @ts-ignore
import video from "./video/video.mp4";
export const IMAGES = {
  banner_logo,
  banner_sidelayer,
  footer_logo,
  bannerapple_img1,
  bannergoogle_img2,
  bannerphone1_img,
  banner_sidecircle1,
  banner_sidecircle2,
  feature_circle,
  featurephoneback_img,
  featurephone_img,
  astrologer,
  chat,
  call,
  horoscope,
  coslultation,
  search_sidecircle,
  search_phoneback,
  search_phone1,
  search_phone2,
  search_phone3,
  search_phone4,
  manage_sidecircle,
  manage_phoneback,
  manage_phone1,
  manage_phone2,
  statistics_sidelayer,
  faq_icon,
  image_sidecircle,
  image_videosession,
  offer_sidelayer,
  ion_call,
  ic_round_email,
  video,
  no_user
};